export default "__VITE_ASSET__BKiUd5Eb__"